import React, { useEffect, useState } from "react";
import { constants } from "../utils/constants";

export const LazyUserAvatar = ({ src, alt = "", onClick }) => {
  const [loaded, setLoaded] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src || constants.ClientImage);

  useEffect(() => {
    setLoaded(false);
    setCurrentSrc(src || constants.ClientImage);
  }, [src]);

  return (
    <div className="custom-img" style={{ position: "relative" }}>
      {!loaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "#e9ecef",
            borderRadius: "4px",
          }}
        />
      )}
      <img
        loading="lazy"
        decoding="async"
        onClick={onClick}
        onLoad={() => setLoaded(true)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          setCurrentSrc(constants.ClientImage);
        }}
        src={currentSrc}
        className={"img-table img-thumbnail w-100 h-100"}
        alt={alt}
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.2s ease" }}
      />
    </div>
  );
};

export const ListLoadMoreIndicator = ({ loadingMore, hasMore, totalRows, entityLabel = "records" }) => {
  if (loadingMore) {
    return (
      <div
        className="users-load-more-indicator"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: "12px",
          zIndex: 5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          margin: "0 12px",
          padding: "12px 16px",
          border: "1px solid #f0d0d0",
          borderRadius: "8px",
          background: "rgba(255, 255, 255, 0.98)",
          color: "#961b1a",
          fontSize: "13px",
          fontWeight: 500,
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
        }}
      >
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          style={{ width: "1.1rem", height: "1.1rem", borderWidth: "0.15em" }}
        />
        <span>Loading more {entityLabel}...</span>
      </div>
    );
  }

  if (!loadingMore && !hasMore && totalRows > 0) {
    return (
      <div
        className="users-load-more-end"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: "12px",
          zIndex: 4,
          textAlign: "center",
          margin: "0 12px",
          padding: "10px 16px",
          color: "#6c757d",
          fontSize: "13px",
          border: "1px solid #e9ecef",
          borderRadius: "8px",
          background: "#fff",
        }}
      >
        Showing all {totalRows} {entityLabel}
      </div>
    );
  }

  return null;
};
